import styled from 'styled-components';

export const LanguageBadgesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--xxsmall-padding);
`;

export const LanguageBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 40px;
  height: 20px;
  background: var(--green-opacity-lighter);
  color: var(--green-color);
  font-size: var(--xxsmall-font-size);
  border-radius: var(--grand-border-radius);
`;
